"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPanelCommerceEndpoints = createPanelCommerceEndpoints;
/**
 * PANEL SATIŞ ADAYLARI, KURUMLAR VE KREDİ (kurum satışla açılır · Story B4,
 * C1, C2, D5). Hepsi `/panel/*` altındadır: ürün jetonu burada geçmez,
 * personel guard zinciri yetkiyi sunucuda verir (satış adayı
 * `staff:sales_inquiry_manage`, kurum `staff:organization_provision`, kredi
 * `staff:credit_manage`).
 *
 * Ayrı dosyadır: `admin.ts` panelin moderasyon/pano ailesidir ve bu gruplar
 * onunla hiçbir yolu paylaşmaz. Tutar ya da para alanı hiçbir gövdede yoktur.
 */
function createPanelCommerceEndpoints(client) {
    return {
        panelSales: {
            list: (query) => client.call('/panel/sales-inquiries', 'get', { query: query }),
            /** Yalnız durum sayıları (kişi yok, denetim satırı yazılmaz): kenar menü rozeti. */
            counts: () => client.call('/panel/sales-inquiries/counts', 'get', {}),
            /** Kişisel veriye erişimdir: her çağrı sunucuda denetim defterine yazılır. */
            get: (id) => client.call('/panel/sales-inquiries/{id}', 'get', { path: { id } }),
            changeStatus: (id, input) => client.call('/panel/sales-inquiries/{id}/status', 'patch', { path: { id }, body: input }),
        },
        panelOrganizations: {
            list: (query) => client.call('/panel/organizations', 'get', { query: query }),
            get: (id) => client.call('/panel/organizations/{id}', 'get', { path: { id } }),
            provision: (input) => client.call('/panel/organizations', 'post', { body: input }),
            /** TP1 ön kontrolü: adres bir kişisel hesaba mı kayıtlı (yalnız ikili olgu). */
            checkOwnerEmail: (input) => client.call('/panel/organizations/owner-email-check', 'post', { body: input }),
            inviteOwner: (id, input) => client.call('/panel/organizations/{id}/owner-invitation', 'post', {
                path: { id },
                body: input,
            }),
            resendOwnerInvitation: (id) => client.call('/panel/organizations/{id}/owner-invitation/resend', 'post', {
                path: { id },
            }),
            revokeOwnerInvitation: (id) => client.call('/panel/organizations/{id}/owner-invitation', 'delete', { path: { id } }),
            /**
             * Kurum kapağını gerekçeyle kaldırır (kurum kapağı · Story P1,
             * `staff:organization_cover_remove`). Gövde personelin gördüğü kapağın
             * kimliğini taşır; kapak bu arada değiştiyse 409. Yanıt güncel detaydır.
             */
            removeCover: (organizationId, input) => client.call('/panel/organizations/{organizationId}/cover/removal', 'post', {
                path: { organizationId },
                body: input,
            }),
            /**
             * Kurumun bitmiş etkinliklerinin rapor özeti (organizatör raporu Story 5,
             * `staff:organization_provision`). Salt okunur, yalnız toplu sayı.
             */
            eventReports: (organizationId) => client.call('/panel/organizations/{organizationId}/event-reports', 'get', {
                path: { organizationId },
            }),
            /**
             * Kurumun bitmiş etkinliklerinde belge ve anket durumu (belge ve anket Story 8,
             * `staff:organization_provision`). Cevap sayısı 5'in katı, cevap içeriği yok.
             */
            postEvent: (organizationId) => client.call('/panel/organizations/{organizationId}/post-event', 'get', {
                path: { organizationId },
            }),
            /**
             * Kurum detayındaki "Anketi kapat" (belge ve anket Story 8). Yol etkinlik
             * ağacındadır ve AYRI yetki ister (`staff:moderate`); gerekçe zorunlu, ikinci
             * kapatma 409.
             */
            disableEventSurvey: (eventId, input) => client.call('/panel/events/{eventId}/survey/disable', 'post', {
                path: { eventId },
                body: input,
            }),
        },
        panelCredits: {
            overview: (organizationId) => client.call('/panel/organizations/{organizationId}/credits', 'get', {
                path: { organizationId },
            }),
            ledger: (organizationId, query) => client.call('/panel/organizations/{organizationId}/credits/ledger', 'get', {
                path: { organizationId },
                query: query,
            }),
            grant: (organizationId, input) => client.call('/panel/organizations/{organizationId}/credits/grants', 'post', {
                path: { organizationId },
                body: input,
            }),
            reverse: (organizationId, grantId, input) => client.call('/panel/organizations/{organizationId}/credits/grants/{grantId}/reversals', 'post', { path: { organizationId, grantId }, body: input }),
            createContract: (organizationId, input) => client.call('/panel/organizations/{organizationId}/credits/contracts', 'post', {
                path: { organizationId },
                body: input,
            }),
            terminateContract: (organizationId, contractId, input) => client.call('/panel/organizations/{organizationId}/credits/contracts/{contractId}/termination', 'post', { path: { organizationId, contractId }, body: input }),
        },
        /**
         * REFERANS (HEDİYE) KODLARI (`staff:credit_manage`). Silme ucu YOKTUR, kod
         * yalnız pasifleşir; düzenleme gövdesinde ad ve hediye sayısı bulunmaz.
         */
        panelReferralCodes: {
            list: (query) => client.call('/panel/referral-codes', 'get', { query: query }),
            create: (input) => client.call('/panel/referral-codes', 'post', { body: input }),
            update: (id, input) => client.call('/panel/referral-codes/{id}', 'patch', { path: { id }, body: input }),
            /** Kod başına kullanımlar (Story 6), en yeni önce; kurum yalnız ad + logo. */
            redemptions: (id, query) => client.call('/panel/referral-codes/{id}/redemptions', 'get', {
                path: { id },
                query: query,
            }),
        },
    };
}
//# sourceMappingURL=panel-commerce.js.map